import React from 'react';
import { trustPoints } from '../../mock';
import * as Icons from 'lucide-react';

const TrustSection = () => {
  return (
    <section className="bg-warm py-24 md:py-32 border-y border-divider">
      <div className="max-w-[1200px] mx-auto px-6 md:px-10">
        <div className="text-center reveal">
          <div className="gold-divider mb-4">
            <span className="chapter-badge text-gold uppercase">{trustPoints.eyebrow}</span>
          </div>
          <h2 className="font-serif-display text-navy text-4xl md:text-5xl leading-[1.1] font-medium">
            {trustPoints.headline}
          </h2>
          <p className="mt-4 font-serif-editorial text-navy/70 text-lg md:text-xl max-w-2xl mx-auto">
            {trustPoints.sub}
          </p>
        </div>

        <div className="mt-16 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-6 md:gap-4">
          {trustPoints.items.map((it, i) => {
            const Icon = Icons[it.icon] || Icons.Sparkles;
            return (
              <div
                key={i}
                className="reveal group relative bg-cream border border-divider p-6 md:p-7 flex flex-col items-center text-center transition-colors duration-500 hover:bg-warm"
              >
                <div className="absolute -top-3 left-1/2 -translate-x-1/2 chapter-badge uppercase bg-gold text-warm px-2 py-1 tracking-widest">
                  {String(i + 1).padStart(2, '0')}
                </div>
                <div className="mt-3 w-14 h-14 rounded-full border border-gold/40 flex items-center justify-center">
                  <Icon size={22} className="text-gold" strokeWidth={1.4} />
                </div>
                <p className="mt-5 font-serif-editorial text-navy text-lg leading-snug">
                  {it.text}
                </p>
              </div>
            );
          })}
        </div>

        <div className="mt-14 text-center reveal">
          <a href="/activate" className="btn-primary inline-block">Activate Your Voucher</a>
        </div>
      </div>
    </section>
  );
};

export default TrustSection;
